"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constant_1 = require("../constant");
var f = require("./fingerprint");
function genChannelContent2Str(channelContent) {
    var _a = channelContent.type, type = _a === void 0 ? "" : _a, _b = channelContent.order, order = _b === void 0 ? "00" : _b, content = channelContent.content, productOrder = channelContent.productOrder, ret = [];
    content = encodeURIComponent(content);
    if (type === constant_1.ComponentType.Product) {
        order = "00";
        content = "00";
    }
    order = padStart(order, 2);
    ret = [type, order, content];
    if (typeof productOrder !== "undefined") {
        productOrder = padStart(productOrder, 2);
        ret.push(productOrder);
    }
    return ret.join("|");
}
exports.genChannelContent2Str = genChannelContent2Str;
function matchInHost(domains) {
    var host = location.host;
    return domains.some(function (h) { return host.indexOf(h) > -1; });
}
exports.matchInHost = matchInHost;
function isEzbuyTrunkLocalDev() {
    var port = location.port;
    return (matchInHost(["192.168."]) || matchInHost(["localhost"])) && (port === "8888" || port === "8080");
}
exports.isEzbuyTrunkLocalDev = isEzbuyTrunkLocalDev;
function isEzbuyMCLocalDev() {
    var port = location.port;
    return (matchInHost(["192.168."]) || matchInHost(["localhost"])) && (port === "8890" || port === "8866");
}
exports.isEzbuyMCLocalDev = isEzbuyMCLocalDev;
function padStart(num, len, ch) {
    if (len === void 0) { len = 2; }
    if (ch === void 0) { ch = "0"; }
    var output = "" + num;
    while (output.length < len) {
        output = "" + ch + output;
    }
    return output;
}
exports.padStart = padStart;
exports.fingerprint = f.fingerprint;
